@if (uploadedFileLabel) {
  <div class="file-upload-selected-container">
    <div class="uploaded-file-item">
      <rkt-icon class="file-status" name="check"></rkt-icon>
      <div class="name">{{ uploadedFileLabel }}</div>
      <button type="button" (click)="onReplaceBtnClick()" class="delete-file-btn">Replace</button>
    </div>
  </div>
}

@if (fileName) {
  <div class="file-upload-selected-container">
    <div class="uploaded-file-item">
      <rkt-icon class="file-status" name="check"></rkt-icon>
      <div class="name">{{ fileName }}</div>
      <button type="button" (click)="onDeleteFileBtnClick()" class="delete-file-btn">Delete</button>
    </div>
  </div>
} @else {
  <div
    [hidden]="uploadedFileLabel"
    class="file-upload-container"
    [class.hovering]="isDragging"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="stopDrag($event)"
    (dragend)="stopDrag($event)"
  >
    <!-- KOR-15210: the whole drop zone opens the picker, and says what it takes (Figma 8280:7004) -->
    <button type="button" class="upload-btn" (click)="fileSelector.click()">
      <rkt-icon name="upload" class="upload-btn-icon"></rkt-icon>
      <span class="upload-btn-title">{{ title }}</span>
      <span class="upload-btn-hint">{{ fileFormats }} · Max {{ maxFileSizeMb }}MB</span>
    </button>
    <input #fileSelector type="file" [accept]="fileTypes.join(', ')" (change)="onFileSelected($event)" hidden />
  </div>
}
